import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Flex, Select, Divider, Row, Col, Statistic, Modal, Descriptions, Tabs } from 'antd';
import CustomerService from "services/customer"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate } from 'react-router';
import InfoModal from "./InfoModal"
import _ from "lodash"
const service = new CustomerService();
const { Search } = Input;
const CustomerInfo = ({ phone, children  }) => {






    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };



    return (
        <>
            {children  ?
                <>
                    <div onClick={showModal}>
                        {children }
                    </div>

                </>
                :
                <>
                    {phone &&
                        <Button type="link" onClick={showModal}>
                            Thông tin
                        </Button>
                    }

                </>
            }

            <InfoModal phone={phone} open={isModalOpen} onClose={e => setIsModalOpen(false)}  ></InfoModal>


        </>

    )
}

export default CustomerInfo;
